"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAutocompleteSource = void 0;
const scrollable_source_hook_1 = require("../../../utils/scrollable-source-hook");
const react_1 = require("react");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const crud_source_hook_1 = require("../../../utils/crud-source-hook");
function useAutocompleteSource({ url, apiUrl, params, }) {
    const loadDetail = event_callback_hook_1.useEventCallback(async (item) => {
        if (apiUrl !== undefined) {
            const fetch = crud_source_hook_1.defaultGetItem(apiUrl, item.id);
            const detail = await fetch.json();
            return detail;
        }
        return Promise.resolve(item);
    });
    const source = scrollable_source_hook_1.useScrollableSource({
        url,
        params,
    });
    const setSearchQuery = event_callback_hook_1.useEventCallback((q) => {
        source.setUrl(`${url}?query=${encodeURIComponent(q)}`);
    });
    return react_1.useMemo(() => ({
        ...source,
        setSearchQuery,
        loadDetail,
    }), [source, setSearchQuery, loadDetail]);
}
exports.useAutocompleteSource = useAutocompleteSource;
//# sourceMappingURL=autocomplete-source-hook.js.map